__turbopack_context__.v({
  "Image": "Member-module-sass-module__5fntia__Image",
  "Member": "Member-module-sass-module__5fntia__Member",
  "MemberInfo": "Member-module-sass-module__5fntia__MemberInfo",
});
